import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AddFeeToAllComp from "./Component/AddFeeToAllComp"


const AddFeeToAll =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AddFeeToAllComp />
        </div>
        <Footer />
        </>
    )
}

export default AddFeeToAll